import { useCallback, useRef, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import MediaService from '../../services/MediaService'
import UnitNavigation from '../../components/Navigation/UnitNavigation'
import Surprise from '../../components/World/Surprise/Surprise'
import { GetUserVideo, getVideo } from '../../s3Func/s3Download'

const Module4Nav = () => {
	const { module4 } = useSelector((state) => state.module4, shallowEqual)
	const { login } = useSelector((state) => state.loginReducer, shallowEqual)

	/*****************
	 *  BG Image Logic
	 * ***************/

	const [displaySurprise, setDisplaySurprise] = useState(false)
	const [surpriseConfig, setSurpriseConfig] = useState(null)
	const bgImage = useRef()

	const checkScreenSize = () => {
		const desktopImage =
			'/Module4Images/Module4NavImages/JourneyMap_Background.png'
		const mobileImage = '/Module4Images/Module4NavImages/M4_Path_Mobile.png'

		bgImage.current =
			window.screen && window.screen.width < 1025 ? mobileImage : desktopImage
	}

	const resizeListener = useCallback(() => {
		window.addEventListener(
			'resize',
			(event) => checkScreenSize(event.target),
			true
		)
	}, [])

	resizeListener()
	checkScreenSize()

	const backgroundPath =
		bgImage.current && MediaService.getImage(bgImage.current, login)
	const worldBG = MediaService.getImage(
		'/Module4Images/Module4NavImages/JourneyMap_Background.png',
		login
	)

	/*****************
	 *  Day Logic
	 * ***************/

	const getDayConfig = useCallback((dayNumber) => {
		let filledImageUrl = `/Module4Images/Module4NavImages/Day${dayNumber}.png`
		let outlinedImageUrl = `/Module4Images/Module4NavImages/Outline_Day${dayNumber}.png`

		// The trophy image is a png instead of a svg, that&apos;s why we do this
		if (dayNumber === 9) {
			outlinedImageUrl = '/Module1Images/Module1NavImages/Outline_Day9.png'
			filledImageUrl = '/Module1Images/Module1NavImages/Color_Day9.png'
		}

		return {
			dayNumber,
			destiny: '/posture',
			filledImageUrl,
			outlinedImageUrl,
		}
	}, [])

	const daysArray = [...Array(9).keys()]
	const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1))

	const SURPRISE_VIDEO = {
		video: '2126608e7693c5b6e9688c276a82/480.m3u8',
		song: 'appfiles/posture/posture_student_instrumental.m4a',
		slides: [
			`influencers/${login.influencerid}/respond_affirmation.mp4`,
			`userfiles/${module4.StudentID}/posture_celebration_surprise_6.mp4`,
			`userfiles/${module4.StudentID}/posture_smile.jpg`,
			`influencers/${login.influencerid}/posture_video_message.mp4`,
			`userfiles/${module4.StudentID}/posture_celebration_surprise_8.mp4`,
			`userfiles/${module4.StudentID}/posture_silly_photo_3.jpg`,
			`userfiles/${module4.StudentID}/posture_celebration_surprise_9.mp4`,
		],
	}

	const handleSurpriseClick = async () => {
		let { slides, song, video } = SURPRISE_VIDEO

		slides = await Promise.all(
			slides.map(async (url) => await GetUserVideo(url, login))
		)
		song = await getVideo(song, login)

		setSurpriseConfig({ video, slides, song })
		setDisplaySurprise(true)
	}

	/*****************************
	 *  Component configuration
	 * ***************************/

	return (
		<>
			{displaySurprise && (
				<Surprise
					background={worldBG}
					setDisplaySurprise={setDisplaySurprise}
					video={surpriseConfig.video}
					song={surpriseConfig.song}
					slides={surpriseConfig.slides}
					onSurpriseEnded={() => setDisplaySurprise(false)}
				/>
			)}

			{backgroundPath && (
				<UnitNavigation
					moduleName="MODULE4"
					module={module4}
					days={DAYS_CONFIG}
					totalDays={9}
					unitDestiny="/unit1"
					nextDestiny="/unit1"
					backgroundPath={backgroundPath}
					onSurpriseClick={handleSurpriseClick}
					unit={1}
					animal={MediaService.getImage('/Images/Button_monkeyHead.png', login)}
				/>
			)}
		</>
	)
}
export default Module4Nav
